.heading {
  font-weight: bold;
  font-size: var(--font-size-md);
  color: var(--text-color-body);
}

.actions {
  margin-top: var(--space-sm);

  ul {
    list-style-type: disc;
  }
}
